import React, { useState } from 'react'
import { useEffect } from 'react';
import { Table } from 'react-bootstrap'
import { GetAllCustomers } from '../APICalls';
import useMedia from 'use-media';

function TotalCustomers() {

    const [totalCustomers, setTotalCustomers] = useState([]);

    const getCustsomers = async () => {
        const res = await GetAllCustomers();
        console.log(res);
        setTotalCustomers(res?.customers)
    }

    useEffect(() => {
        getCustsomers()
    }, [])

    const isMobileScreen = useMedia('max-width:600px')


    return (
        <div className="main-content h-80 " style={{marginTop: isMobileScreen?  '120px' : '40px'}}>
            <main className="content">


                <Table striped bordered hover className='w-75' style={{ margin:'0 auto',minWidth:'400px', maxWidth:'600px' }} >
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Customer Code</th>
                            <th>Name</th>
                            <th>Number</th>
                        </tr>
                    </thead>
                    <tbody>
                        {totalCustomers?.length > 0 ?
                            (totalCustomers.map((cust, i) => (
                                <tr>
                                    <td> {i + 1} </td>
                                    <td>{cust?.customer_code}</td>
                                    <td>{cust?.customer_name}</td>
                                    <td>{cust?.customer_number}</td>
                                </tr>
                            )))
                            :
                            <tr  >
                                <td colSpan={4} className='text-center' >No Data Found </td>
                            </tr>
                        }
                    </tbody>
                </Table>

            </main>
        </div>

    )
}

export default TotalCustomers
